/// <reference types="./file.d.mts" />
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import {
  new_ as new$,
  text,
  bytes,
  name,
  mime as do_mime,
  size,
  createObjectURL as create_object_url,
  readFromEvent as from_event,
  download,
} from "./file.ffi.mjs";

export { bytes, create_object_url, download, from_event, name, new$, size, text };

export function mime(file) {
  let mime$1 = do_mime(file);
  return $bool.guard(
    mime$1 !== "",
    mime$1,
    () => {
      let name$1 = name(file);
      return $bool.guard(
        $string.ends_with(name$1, ".md"),
        "text/markdown",
        () => { return "text/plain"; },
      );
    },
  );
}
